import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import ProfileActivity from '../../../../v2BaseComponents/ProfileActivity';

export type ProfileActivityScreenOwnProps = {};

export type ProfileActivityScreenProps = ProfileActivityScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'profile-activity'>;
};

const ProfileActivityScreen: React.FC<ProfileActivityScreenProps> = ({ route }) => {
    return <ProfileActivity profileId={route.params.profileId} />;
};

export default React.memo(ProfileActivityScreen);
